@if (updateAvailable()) {
  <div class="sx-update-banner" role="status" aria-live="polite">
    <div class="sx-update-banner__content">
      <span class="sx-update-banner__icon" aria-hidden="true">
        <lucide-icon [img]="icons.refresh" class="h-3.5 w-3.5"></lucide-icon>
      </span>
      <p class="sx-update-banner__text">
        A new version of Synexa is available.
      </p>
      <button type="button" class="sx-btn sx-btn-primary sx-update-banner__action" (click)="reload()">
        Reload
      </button>
    </div>
    <button
      type="button"
      class="sx-update-banner__dismiss"
      aria-label="Dismiss update notice"
      (click)="dismiss()"
    >
      <lucide-icon [img]="icons.close" class="h-4 w-4"></lucide-icon>
    </button>
  </div>
}
